import React, { ReactNode } from 'react';
import DialogProvider from './DialogProvider';
import DrawerProvider from './DrawerProvider';
import LoadingProvider from './LoadingProvider';
import SessionExpiredModalProvider from './SessionExpiredModalProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

const Providers = ({ children }: { children: ReactNode }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <LoadingProvider>
        <SessionExpiredModalProvider>
          <DialogProvider>{children}</DialogProvider>
        </SessionExpiredModalProvider>
      </LoadingProvider>
    </QueryClientProvider>
  );
};

export default Providers;
